module.exports = __webpack_public_path__ + "static/img/A (26).50bbe502.png";